let styleSSO = `
.sso-bg-neutral-100 {
 background-color: #ffffff !important;
  border-bottom-color: #771611!important;
}
.labelSpan {
    color: #fff !important;
}
body > sso-app > div > div > app-sign-in > div > div.sso-text-center > div {
  color: #FA2727 !important;
}
body > sso-app > div > div > app-sign-in > div > app-header > header > section > div:nth-child(2) > p {
  color: #000000 !important;
  background-color: #ffffff !important;
}
sso-app > div > div > app-result > div,
sso-app > div > div > app-result > div > div.line.ng-star-inserted {
  background-color: #771611!important;
}
.sso-text-primary-500,
sso-app > div > div > app-phone-verification > div > div.info-text > p,
sso-app > div > div > app-sms-verification > div > div.sso-mx-12 > p,
sso-app > div > div > app-sms-verification > div > form > div > p,
sso-app > div > div > app-result > div > div.sso-container > div > h1,
sso-app > div > div > app-result > div > div.sso-container > div > p {
  color: black !important;
text-decoration-color: #FA2727 !important;

}
.uil-times-circle::before,
.uil-arrow-left::before {
  color: #000000 !important;
}
sso-app > div > div > app-phone-verification > div > div.info-text > p > span {
  color: #000000 !important;
  text-decoration: underline !important;

}

sso-app > div > div > app-phone-verification > div > .info-text[_ngcontent-cxp-c53] {
    margin-left: auto !important;
    width: 80% !important;
    margin-right: auto !important;

}


sso-app > div > div > app-sign-in > div > div.sso-text-center > div {
  font-size: 1rem !important;
}
app-sign-in > div > .sso-text-center,
.sso-container,
sso-app > div > div > app-phone-verification > div,
sso-app > div > div > app-sms-verification > div {
    background-color:  #FCF2EB !important;
}
.sso-container {
    background-image: url(https://tapitdev.vteximg.com.br/arquivos/mask-bg-emb.png) !important;
    background-size: cover !important;
    background-repeat: no-repeat;
    background-position: center center;
    background-color:  #FCF2EB !important;

  }
.sso-text-base  {
  font-size: 0.9rem !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.sso-secondary-button,
sso-app > div > div > app-phone-verification > div > form > div > ngx-intl-tel-input {
  background-color: white;

}
app-sign-in > div > div.sso-container > div > p,
sso-app > div > div > app-phone-verification > div > p {
  background-color: #F9F5F1  !important;
  color: #000000 !important;
}
app-sign-in > div > div.sso-container > div > span {
  border-bottom-color:  #000000 !important;
}
.sso-label {
  color:  #716C6A !important;
  font-weight: 400!important;
}
sso-app > div > div > app-sign-in > div > div.sso-container > form > button,
sso-app > div > div > app-sign-up > div > div.sso-container > form > button,
sso-app > div > div > app-recover-password > div > div.sso-container > form > button,
sso-app > div > div > app-recover-password > div > div.sso-container > button,
sso-app > div > div > app-phone-verification > div > form > div.button-phone > button,
sso-app > div > div > app-sms-verification > div > form > div.button-content > button,
sso-app > div > div > app-result > div > div > div.sso-text-center > div > button {
  background-color: #FA2727 !important;
 border-radius: 20px !important;
  color: white !important;
}
sso-app > div > div > app-sign-in > div > div.sso-container > form > button:hover,
sso-app > div > div > app-sign-up > div > div.sso-container > form > button:hover,
sso-app > div > div > app-recover-password > div > div.sso-container > form > button:hover,
sso-app > div > div > app-recover-password > div > div.sso-container > button:hover,
sso-app > div > div > app-phone-verification > div > form > div.button-phone > button:hover,
sso-app > div > div > app-sms-verification > div > form > div.button-content > button:hover,
sso-app > div > div > app-result > div > div > div.sso-text-center > div > button:hover {
  color: #fff !important;
  background-color: #FA1010  !important;
}
sso-app > div > div > app-sign-in > div > div.sso-container > form > button:active,
sso-app > div > div > app-sign-up > div > div.sso-container > form > button:active,
sso-app > div > div > app-recover-password > div > div.sso-container > form > button:active,
sso-app > div > div > app-recover-password > div > div.sso-container > button:active,
sso-app > div > div > app-phone-verification > div > form > div.button-phone > button:active,
sso-app > div > div > app-sms-verification > div > form > div.button-content > button:active,
sso-app > div > div > app-result > div > div > div.sso-text-center > div > button:active {
  background-color: #771611!important;
  color: black !important;
}
sso-app > div > div > app-sign-in > div > div.sso-container > form > button:focus,
sso-app > div > div > app-sign-up > div > div.sso-container > form > button:focus,
sso-app > div > div > app-recover-password > div > div.sso-container > form > button:focus,
sso-app > div > div > app-recover-password > div > div.sso-container > button:focus,
sso-app > div > div > app-phone-verification > div > form > div.button-phone > button:focus,
sso-app > div > div > app-sms-verification > div > form > div.button-content > button:focus,
sso-app > div > div > app-result > div > div > div.sso-text-center > div > button:focus {

}
sso-app > div > div > img.sso-w-16.sso-absolute.sso-left-0.sso-bottom-0 {
  box-sizing: border-box !important;
  display: block !important;
  width: 65px !important;
  height: 75px !important;
  padding-left: 65px;
  background: url(https://tapitdev.vteximg.com.br/arquivos/bubble_31.png) !important;
}
sso-app > div > div > img.sso-w-16.sso-absolute.sso-right-0.sso-bottom-0 {
  box-sizing: border-box !important;
  display: block !important;
  width: 99px !important;
  height: 54px !important;
  padding-left: 99px;
  background: url(https://tapitdev.vteximg.com.br/arquivos/bubble_41.png) !important;
}
sso-app > div > div > app-sign-up > div > div > h1 {
  visibility: hidden !important;
}

body > sso-app > div > div > app-sms-verification > div > form > p > span, body > sso-app > div > div > app-sms-verification > div > div.sso-mx-12.sso-mt-4 > p.sso-text-center.sso-mt-4.sso-underline.sso-text-primary-500.ng-star-inserted > span, body > sso-app > div > div > app-sms-verification > div > div.sso-mx-12.sso-mt-4 > p.sso-text-center.sso-mt-4.sso-underline.sso-text-primary-500.ng-star-inserted  {
  color: #FA2727 !important;
  text-decoration-color: #FA2727 !important;
}

body > sso-app > div > div > app-sms-verificationapp-sms-verification > div > form > p {
   color: #FA2727 !important;
}

body > sso-app > div > div > app-phone-verification > div, body > sso-app > div > div > app-sms-verification > div{
  background-image: url(https://tapitdev.vteximg.com.br/arquivos/mask-bg-embajadores.png) !important;
   background-size: cover !important;
    background-repeat: no-repeat;
    background-position: center center;
    background-color:  #FCF2EB !important;
}
sso-app > div > div > app-sign-up > div > div > h1 {
  visibility: visible !important;
  margin-bottom: -2rem !important;
  color: #000000 !important;
text-align: center !important;
  font-size: 18px !important;

}
sso-app > div > div > app-sign-up > div > div > p {
  visibility: hidden !important;
}
sso-app > div > div > app-sign-up > div > div > p {


  visibility: visible !important;
  color: #E5E5E5 !important;

}
sso-app > div > div > app-sign-up > div > div > form > div:nth-child(1) {

}
sso-app > div > div > app-sign-up > div > div > form > div > div > label,
sso-app > div > div > app-sign-up > div > div > form > div:nth-child(1) > div:nth-child(4) > div > div > label {

}
#gender {
  background-color: white !important;
}
sso-app .sso-checkbox input:checked~.sso-checkmark {
  background-color: #FA2727 !important;
  border-color: #FA2727 !important;
}
sso-app > div > div > app-sign-up > div > div > form > div > label > p,
#tapit-terms,
sso-app > div > div > app-recover-password > div > div > p.sso-text-center {
  color: white !important;
}
sso-app > div > div > app-recover-password > div > div > h1 {
  color: white !important;
}
sso-app > div > div > app-recover-password > div > div > form > div > label {
}
@media screen and (min-width: 680px) {
  sso-app > div > div > app-phone-verification > div > div.tapit-logo-container.sso-mx-auto > img,
  sso-app > div > div > app-sms-verification > div > div.tapit-logo-container.sso-mx-auto > img {
    box-sizing: border-box !important;
    display: block !important;

    background: url(/arquivos/tapit-white1.png) !important;
  }

}
@media screen and (max-width: 679px) {
  sso-app > div > div > app-phone-verification > div > div.tapit-logo-container.sso-mx-auto > img,
    sso-app > div > div > app-sms-verification > div > div.tapit-logo-container.sso-mx-auto > img {
    box-sizing: border-box !important;
    display: block !important;

    background: url(/arquivos/tapit-white2.png) !important;
  }


  sso-app > div > div > app-phone-verification > div > .info-text  {

    width: 50% !important;

}


}

body > sso-app > div > div > app-sign-in > div > div.sso-container.sso-mx-auto.sso-relative.sso-bg-white.sso-px-12.sm\:sso-px-28.sso-pb-24.sso-overflow-y-auto.sso-flex-1 > a {
  color: #000000 !important;
}
body > sso-app > div > div > app-sign-in > div > app-header > header > section > div:nth-child(2) > p > span {
  color: #FA2727 !important;

}
body > sso-app > div > div > app-sign-up > div > div > h1::before {
  color: black !important;
}
body > sso-app > div > div > app-sign-up > div > div > p::before {
  font-weight: 100 !important;
  color: black !important;
}
body > sso-app > div > div > app-sign-up > div > div > form > div.sso-text-left.sso-mb-4 > label > p,
#tapit-terms,
body > sso-app > div > div > app-recover-password > div > div > h1,
body > sso-app > div > div > app-recover-password > div > div > p,
body > sso-app > div > div > app-recover-password > div > div {
  color: black !important;

}

#tapit-terms > a:nth-child(1), #tapit-terms > a:nth-child(2){
  color: #FA2727 !important;
}

body > sso-app > div > div > app-recover-password > div > div > p {
  color: red !important;
}
sso-app > div > div > app-sign-up > div > div > form > div > label > p, #tapit-terms, sso-app > div > div > app-recover-password > div > div > p.sso-text-center {
  color: black !important;
}
#mat-dialog-5 > sso-dialog > header > button > i {
  color: white !important;
}
#mat-dialog-2 > sso-dialog > header,
#mat-dialog-2 > sso-dialog > section > div > button {
  background: #771611 !important;
}
#mat-dialog-2 > sso-dialog > section,
#mat-dialog-2 {
  background: #F9F5F1 !important;
}
`;

const TAPIT_SSO_CONFIG = {
  /* String type parameter to indicate the application that is sending the request. */
  origin: "tapit_tapit_web_embajadoresabi_202203",
  project: "tapit_tapit_web_embajadoresabi_202203" /*it will be deprecated*/,
  /* String type parameter for the logo image URL or the base64 image. */
  logoUrl:
    "data:image/png;base64,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",
  /* String type parameter for the slogan in HTML tag format. Example: <p>Our Slogan</p>. */
  sloganHtml:
    '<p class="sso-text-center sso-text-xs">La comunidad de los <span class="sso-text-primary-500">amantes de la cerveza.</span></p>',
  /* Boolean type parameter to show the signIn facebook button. */
  showFacebookButton: true,
  showLoginFacebookButton: true /*it will be deprecated*/,
  showSignUpFacebookButton: true /*it will be deprecated*/,
  /* Boolean type parameter to show the sign form. */
  showSignUpForm: true,
  showSignUPWithFields: true /*it will be deprecated*/,
  /* Boolean type parameter to show offers options. */
  showOffersOption: true,
  /* String type parameter for sample mail to be displayed as a value within the email field. */
  loginEmail: "",
  /* String type parameter to show a suggestion of mail or text under the email field. Empty by default */
  loginEmailHint: "",
  /* String type parameter to show a suggestion of password or text under the password field. Empty by default */
  loginPasswordHint: "",
  /* String type parameter for legend of acceptance of terms and conditions when the user registers, in HTML tag format. SSO can recognize and apply tailwind css classes */
  signUpAcceptTermsHtml:
    '<h1 class="sso-text-sm sso-font-bold sso-mb-1 sso-text-left">Al registrarte estás aceptando:</h1><p class="sso-text-sm sso-text-left">Nuestros <a class="sso-text-primary-500" href="/terms.html" target="_blank">Términos y Condiciones de Tapit,</a> las <a class="sso-text-primary-500" href="/privacy.html" target="_blank">Políticas de Privacidad,</a> la <a class="sso-text-primary-500" href="/data-proteccion.html" target="_blank">Política de protección de datos personales.</a> <br><br> El procesamiento de mi información personal por parte de Bavaria & Cía S.C.A. con las finalidades y usos requeridos por cerveza Poker descritos en la mencionada política. <br><br> Confirmo ser mayor de 18 años.</p>',
  /* String type parameter for legend of acceptance of sending offers when the user registers, in HTML tag format. SSO can recognize and apply tailwind css classes */
  signUpAcceptOffersHtml:
    '<p class="sso-text-sm sso-text-left">Acepta para recibir actualizaciones sobre el mundo de la cerveza y obtén nuestras ofertas exclusivas! Sólo las enviamos a nuestros #BeerLovers (Te prometemos no enviar spam)</p>',
  /* String type parameter for legend of acceptance of terms and conditions when the user registers, in HTML tag format. SSO can recognize and apply tailwind css classes */
  loginFooterHtml:
    '<p class="sso-text-sm sso-text-center">Al iniciar sesión estás aceptando nuestros <a class="sso-text-primary-500" href="/terms.html" target="_blank">Términos y Condiciones de Tapit,</a> las <a class="sso-text-primary-500" href="/privacy.html" target="_blank">Políticas de Privacidad,</a> la <a class="sso-text-primary-500" href="/data-proteccion.html" target="_blank">Política de protección de datos personales</a> y el envío de ofertas exclusivas a mi correo. </p>',
  /* Boolean type parameter to show the close button. */
  showCloseButton: true,
  /* Boolean type parameter to show the container background. */
  showContainerBackground: true,
  /* String type parameter to define the language, in case a valid parameter is not sent, the browser language will be taken */
  language: "es",
  /* String type parameter to define the referrer of the iframe (the domain of the current client)*/
  reference: "",
  /* Boolean type parameter to show recover Password link. */
  showRecoverPassword: true,
  /*  String type parameter to add custom stylest in CSS format. Empty by default */
  styles: styleSSO,
  /* Object type parameter to add custom inputs.
      Each custom input must be made up of a key and a label.
      The password will be saved in the database in the interests property, only if the user selects that interest
  */
  interests: [
    { key: "beer", label: "Cerveza" },
    { key: "soccer", label: "Futbol" },
  ],
  interestsMandatory: true,
  showGoogleButton: true,
  showIdentityTypeInput: true,
  defaultIdentityType: "COL_CC",
  identityTypes: [
    { label: "CC", key: "COL_CC" },
    { label: "CPF", key: "BR_CPF" },
  ],
  showIdentityNumberInput: true,
  showPhoneNumberInput: true,
  showGenderInput: true,
  showCityInput: false,
  cities: [
    { label: "BOGOTÁ", key: "bogota" },
    { label: "MEDELLIN", key: "medellin" },
    { label: "CARTAGENA", key: "cartagena" },
  ],
  disableFacebookSignup: false,
};

export default TAPIT_SSO_CONFIG;
